import { createContext, useContext } from 'react';
const context = createContext({});

export const useDevice = () => {
  return useContext(context);
};

export default context.Provider;
